import { z } from 'zod';
const PHONE_REGEX = /^[1-9][0-9]{9,14}$/;
export const PhoneVO = z.string().min(10).max(15).regex(PHONE_REGEX, 'Telefone inválido');
//# sourceMappingURL=phone.js.map